// extracted by mini-css-extract-plugin
module.exports = {"root":"page-not-found_root__2eeEC","title":"page-not-found_title__2ejBo"};